import type { Service, ServiceCategory } from '../../types';

// Helper function to convert Buffer object to base64 string
export const bufferToBase64 = (buffer: { type: string; data: number[] } | string | undefined): string | undefined => {
  if (!buffer) return undefined;
  if (typeof buffer === 'string') return buffer;
  if (buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
    let binary = '';
    for (let i = 0; i < buffer.data.length; i++) {
      binary += String.fromCharCode(buffer.data[i]);
    }
    return btoa(binary);
  }
  return undefined;
};

// Helper functions to get field values with fallbacks
export const getServiceId = (s: Service) => s.id || s.ID || '';
export const getServiceName = (s: Service) => s.nome || s.NOME || '';
export const getServiceLogo = (s: Service) => bufferToBase64(s.logo) || s.LOGO;
export const getServiceMimeType = (s: Service) => s.mimeType || s.MIME_TYPE || 'image/png';
export const getServiceCode = (s: Service) => s.tipoServico || s.codigo || s.CODIGO;
export const getServicePaymentPageId = (s: Service) => s.idPaymentPage || s.ID_PAYMENT_PAGE || s.id;
export const getServiceEntity = (s: Service) => s.entidade || '';

export const getCategoryId = (c: ServiceCategory) => String(c.id || c.ID || '');
export const getCategoryName = (c: ServiceCategory) => c.nome || c.DESIGNACAO || c.DESCRICAO || '';
